export const bankDetails = {
    bank: '[Nombre del Banco]',
    account: '[Número de Cuenta]',
    clabe: '[CLABE Interbancaria]',
    holder: '[Nombres de los Novios]',
};

export interface StoreWishlist {
    name: string;
    description: string;
    icon: string;
    link: string;
}

export const storeWishlists: StoreWishlist[] = [
    {
        name: 'Liverpool',
        description: 'Artículos para el hogar, decoración y electrodomésticos.',
        icon: '🏠',
        link: '#' // TODO: Replace with actual URL
    },
    {
        name: 'Williams Sonoma',
        description: 'Utensilios de cocina y productos gourmet de alta calidad.',
        icon: '🍽️',
        link: '#' // TODO: Replace with actual URL
    },
    {
        name: 'Amazon',
        description: 'Variedad de productos para nuestro nuevo hogar.',
        icon: '✨',
        link: '#' // TODO: Replace with actual URL
    }
];